import { DateTime } from "luxon";
import { InputField } from "../../forms/inputGroup";
import { DatepickerField } from "../../forms/inputGroup/helpers";
import { Form, useFormikContext } from "formik";
import _ from "lodash";
import Select from "react-select";

function FormFieldError({ errors }: { errors?: string }) {
  return errors ? (
    <div className="QuotationRequestModal__container__quotationFormCntr__form__error">
      {_.capitalize(errors)}
    </div>
  ) : (
    <div className="QuotationRequestModal__container__quotationFormCntr__form__error" />
  );
}

type ErrorsType = {
  message?: string;
  title?: string;
  trip_start_date?: string;
  offer_due_date?: string;
  file?: string;
};

export function InitialForm({
  errors,
  subagentOptions,
  source_entity,
}: {
  errors?: ErrorsType;
  subagentOptions: {
    label: string;
    value: string;
    name: string;
    email: string;
    legal_title: string;
  }[];
  source_entity: string;
}) {
  const { setFieldValue, values } = useFormikContext();
  const isMember = source_entity.includes("___member");

  return (
    <Form className="QuotationRequestModal__container__quotationFormCntr">
      <div className="QuotationRequestModal__container__quotationFormCntr__form grid gap-1">
        <div>
          <InputField as="input" label="Title" name="title" />
          <FormFieldError errors={errors?.title} />
        </div>
        {isMember && (
          <div className="grid [&>div>div]:p-1">
            <label className="text-base">Sub-agent</label>
            <Select
              options={subagentOptions}
              name="source_entity"
              value={
                subagentOptions.find(
                  (option) => option.value === (values as { source_entity: string }).source_entity,
                ) || null
              }
              formatOptionLabel={(option) => {
                return (
                  <div>
                    <span>
                      <strong>Name:</strong> {option.name}
                    </span>
                    <br />
                    <span>
                      <strong>Legal Title:</strong> {option.legal_title}
                    </span>
                    <br />
                    <span>
                      <strong>Email:</strong> {option.email}
                    </span>
                  </div>
                );
              }}
              onChange={(option) => {
                if (!option) return;
                setFieldValue("source_entity", option.value);
              }}
            />
          </div>
        )}
        <div className="grid gap-1">
          <DatepickerField
            selectsRange={false}
            name="offer_due_date"
            label="Offer due Date"
            minDate={DateTime.now().toISODate()}
            maxDate={DateTime.now().plus({ years: 3 }).toISODate()}
          />
          <FormFieldError errors={errors?.offer_due_date} />
        </div>
        <div>
          <InputField as="textarea" label="Quotation Request Message" name="message" rows={20} />
          <FormFieldError errors={errors?.message} />
        </div>
      </div>
    </Form>
  );
}
